import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { FeedbackService } from '../../core/services/feedback.service';
import { NotificationService } from '../../core/services/notification.service';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {
  @Input() customer;
  @Input() order;
  @Output() feedbackSubmittedEmitter = new EventEmitter();
  
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private feedbackSerice: FeedbackService,
    private notificationService: NotificationService
  ) {
    this.form = this.formBuilder.group({
      feedback:[null, [Validators.required]],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required]],
      phone: [null, [Validators.required]],
      orderNumber: [null]
    })
  }

  ngOnInit() {
    this.customer.subscribe(customer => {
      this.form.patchValue({
        firstName: customer.first_name,
        lastName: customer.last_name,
        email: customer.email,
        phone: customer.phone_number
      });
    });

    this.order.subscribe(order => {
      if (order) {
        this.form.patchValue({
          orderNumber: order.erp_order_id
        })
      }
    })
  }

  save() {
    if (this.form.invalid) {
      return;
    }

    this.feedbackSerice.submitFeedback(this.form.value).subscribe(
      result => {
        this.feedbackSubmittedEmitter.emit(true);

        this.notificationService.broadcastSuccessNotification({
          message: 'Thank you for your feedback.'
        });
      });
  }
}
